// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/liquidazioni-iva?societaId=&anno=',
    requestBody: null,
    response: '{ success: true, data: [{ id, anno, periodo, tipoPeriodo, label, stato, dataDefinizione, note }], periodicita: \'MENSILE\'|\'TRIMESTRALE\' }'
  },
  {
    method: 'POST',
    endpoint: '/api/liquidazioni-iva',
    requestBody: '{ societaId, anno, periodo, tipoPeriodo }',
    response: '{ success: true, data: { id, stato } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
